export const HOST_CONTAINER_WIDTH = "425px";